import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import FeatureName from "../../../../visComponents/featureName";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {IS_LIXIL_SERVERS, IS_PRODUCT_JOURNEY} from "../../../../../config";
import {getStringFeatureName} from "../../../../../misc/helpers";

const nameLength = IS_PRODUCT_JOURNEY ? 40 : 500;


const LookListFeatureName = (props) => {

  const {lookFeature, intl, fabricatorData, filterGroups} = props;

  if (!IS_LIXIL_SERVERS) {
    return null
  }

  const collectionName = getStringFeatureName(lookFeature, intl.messages, intl.locale, fabricatorData, filterGroups, true);
  const featureName = getStringFeatureName(lookFeature, intl.messages, intl.locale, fabricatorData, filterGroups, false);

  if (featureName === collectionName) {
    return null
  }

  return (
    <p className="lm-feature__content-description">
      <FeatureName feature={lookFeature} maxLength={nameLength}/>
    </p>
  )
};

LookListFeatureName.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {filterGroups} = store.filterState;
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData,
    filterGroups
  };
};

export default injectIntl(
  connect(mapStateToProps)(LookListFeatureName)
)
